<template>
  <div>
    <h2>个性模板制作</h2>
    <el-form
      ref="templateForm"
      :inline="true"
      :model="formData"
      :rules="rules"
      class="searchBoxLine form-wrap"
    >
      <el-form-item label="模板名称:" prop="markTemplateName" clearable>
        <el-input
          v-model="formData.markTemplateName"
          placeholder="请填写模板名称"
          maxlength="255"
          @input="e => formData.markTemplateName = handleInputRule (e)"
        />
      </el-form-item>
      <el-form-item label="客户名称:" prop="customerCode" clearable>
        <el-select
          v-model="formData.customerCode"
          remote
          clearable
          filterable
          reserve-keyword
          placeholder="请填写客户名称"
          :remote-method="remoteMethod"
          :loading="loading"
        >
          <el-option
            v-for="item in customerList"
            :key="item.customerOnlyCode"
            :label="item.customerName"
            :value="item.customerOnlyCode"
          />
        </el-select>
      </el-form-item>
    </el-form>

    <h3>个性模板信息</h3>
    <TemplateInfo ref="templateInfo" v-model="formData.headerFieldList" />

    <h3>产品信息</h3>
    <productInfo ref="productInfo" v-model="formData.productFieldList" />

    <el-button type="primary" @click="handleBtn('save')">
      保存模板
    </el-button>
    <el-button type="primary" @click="handleBtn('see')">
      模板预览
    </el-button>

    <templateSee ref="templateSeeRef" />
  </div>
</template>

<script>
import TemplateInfo from '../template-info/index.vue';
import productInfo from '../productInfo/index.vue';
import templateSee from '../templateSee/index.vue';
import { MSG_TYPE, IS_TRUE } from '@/libs/constant';
import { getCustomerInfo, saveMarkTemplateInfo } from '@/API/markManager.js';
import { handleInputRule } from '@/libs/util.js';

export default {
  components: {
    TemplateInfo,
    productInfo,
    templateSee
  },

  data () {
    return {
      loading: false,
      productInfoForm: {
        isCopyCustomer: false,
        isDeleteCustomer: false,
        isIndexCol: false,
        colName: ''
      },
      msgType: MSG_TYPE,
      isTrue: IS_TRUE,
      // 模板数据存储
      formData: {
        markTemplateName: '',
        markTemplateType: '个性模板',
        customerName: '',
        customerCode: '',
        headerFieldList: [],
        productFieldList: []
      },
      rules: {
        markTemplateName: [
          { required: true, message: '请填写模板名称', trigger: 'blur' }
        ],
        customerCode: [
          { required: true, message: '请填写客户名称', trigger: 'blur' }
        ]
      },
      customerList: []
    };
  },

  methods: {
    handleInputRule,
    // 远程检索客户名称
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true;
        getCustomerInfo({
          customerName: query
        }).then(res => {
          this.loading = false;
          let json = res.data || {};
          if (json.status !== '200') return;
          this.customerList = json.data || [];
        });
      } else {
        this.customerList = [];
      }
    },

    // 模板预览
    handleTemplateSee () {
      this.$refs.templateSeeRef.openDialog({
        formData: this.formData
      });
    },

    // 提交保存表单
    handleSubmit () {
      saveMarkTemplateInfo({ ...this.formData }).then(res => {
        let json = res.data;
        if (json.status !== '200') return;
        this.$message.success(json.err);
        this.$router.go(-1);
      });
    },

    // 按钮事件处理
    handleBtn (params) {
      this.$refs.templateForm.validate(valid => {
        if (!valid) return;
        if (!this.$refs.templateInfo.validateForm()) return;
        if (!this.$refs.productInfo.validateForm()) return;

        // 客户名称取值
        const { customerCode } = this.formData;
        this.customerList.some(item => {
          if (customerCode === item.customerOnlyCode) {
            this.formData.customerName = item.customerName;
            return true;
          }
        });

        // 保存模板做数据处理
        if (params === 'save') {
          this.formData.headerFieldList.forEach(item => {
            delete item.fieldData;
          });
          this.formData.productFieldList.forEach(item => {
            delete item.fieldData;
          });
          delete this.formData.customerIndex;
          this.handleSubmit();
          return;
        }

        this.handleTemplateSee();
      });
    }
  }
};
</script>

<style scoped lang="scss">
</style>
